const AUTH_STORAGE_KEYS = ['sessionToken', 'refreshToken', 'user'] as const

export function removeAuthStorage() {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
}
